<template>
  <v-card class="ma-1" >
        <v-card-media
          class="white--text cardCursor"
          :height="height"
          @click="toArtefact1(artefact._id)"
          :src="artefact.mainImg[0].url+'_card'">
          <v-container class="grayoverlay" style="" fill-height fluid>
            <v-layout fill-height class="d-block">
              <v-flex xs12 class="text-align:left">
                <v-icon medium dark >view_carousel</v-icon> <span class="body-1" style="text-align:left; color:rgba(255,255,255,0.5)" > {{artefact.collectionId[0]}}</span>
              </v-flex>
              <v-flex xs12 align class="mt-5"  style="text-align:left"> <a @click="toArtefact(artefact._id) " style="text-decoration:none; color:white;  cursor:pointer; text-align:left;"> <p class="headline"> <span   class="headline-artefact mb-1 ml-1 ">{{artefact.title[lang].slice(0,30).toUpperCase()}}<span v-if="artefact.title[lang].length >30">...</span></span> </p> </a></v-flex>
            </v-layout>
          </v-container>
        </v-card-media>
      </v-card>
</template>

<script>
export default {
	props: ["artefact", "height"],
	methods: {
		toArtefact(artefactID) {
			this.$router.push("/artefacts/" + artefactID);
		},
		toArtefact1(artefactID) {
			if (window.innerWidth > 950) {
				this.$router.push("/artefacts/" + artefactID);
			}
		}
	},
	computed: {
		lang() {
			return this.$store.getters.loadLang;
		}
	}
};
</script>


<style scoped>
@media screen and (min-width: 950px) {
	.cardCursor:hover {
		cursor: pointer;
		transform: scale(1.025);
	}
	.cardCursor {
		transition: all 0.5s;
	}

	.grayoverlay {
		background-color: rgba(0, 0, 0, 0.5);
		transition: all 0.5s;
	}
	.grayoverlay:hover {
		background-color: rgba(0, 0, 0, 0.2);
	}
}
.headline-artefact {
	position: absolute;
	bottom: 3%;
	left: 3%;
	-webkit-text-stroke-width: 0.3px;
	-webkit-text-stroke-color: black;
}
</style>





// WEBPACK FOOTER //
// src/components/Partials/ArtefactCardMini.vue